import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Amplify, I18n } from "aws-amplify";
import vocabularies from "../translations/vocabularies.json";
import awsExports from "../aws-exports";
import Layout from "../layouts/loginLayout";
import "../assets/style.css";

I18n.putVocabularies(vocabularies);

Amplify.configure(awsExports);

const login = lazy(() => import("./containers/login/login"));
const invites = lazy(() => import("./containers/invites/invites"));
const forgotPsw = lazy(() => import("./containers/forgotPsw/forgotPsw"));
const resetPsw = lazy(() => import("./containers/resetPsw/resetPsw"));
const migrateAccount = lazy(() =>
  import("./containers/migrateAccount/migrateAccount")
);

export default function App() {
  const currentLanguage =
    window.navigator.userLanguage || window.navigator.language;
  const language = currentLanguage.split(/[-_]/)[0]
    ? currentLanguage.split(/[-_]/)[0]
    : currentLanguage;
  I18n.setLanguage(language);

  return (
    <Router basename="/auth">
      <Suspense fallback={() => <div>{I18n.get("loading...")}</div>}>
        <Layout>
          <Switch>
            <Route path="/sign_up" component={invites} />
            <Route path="/login" exact component={login} />
            <Route path="/forgot" exact component={forgotPsw} />
            <Route path="/reset" component={resetPsw} />
            <Route path="/migrate" component={migrateAccount} />
          </Switch>
        </Layout>
      </Suspense>
    </Router>
  );
}
